// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { profileManager } from "../../game_theme/flow_fb/flowController";
import { tgfHooks } from "../framework/hooks/hooks";
import { CustomUpdateSettings } from "../settings/Settings";
import { AngryAnalytics } from "./Analytics/Analytics";
import { NudgeFactory } from "./NudgeFactory";
import { YoutubeStorageManager } from "./storage/YoutubeStorageManager";
export var CustomMessageController = function () {
    this._messageIndex = 0;
    this._backendTag = "customIndex";
    this._inviteTags = CustomUpdateSettings.inviteTags;
    this._initialize();
};
CustomMessageController.prototype._rotateIndex = function (index) {
    "use strict";
    var _index = index;
    if (index === (this._inviteTags.length - 1)) {
        _index = 0;
    }
    else {
        _index++;
    }
    return _index;
};
CustomMessageController.prototype._initialize = function () {
    "use strict";
    var self = this;
    // checking remote server for index data
    YoutubeStorageManager.getPlayerData([self._backendTag], function (data) {
        var curIndex = data[self._backendTag];
        self._messageIndex = Math.round(Math.random() * 2);
        if (curIndex) {
            self._messageIndex = self._rotateIndex(curIndex);
        }
        ;
    });
};
CustomMessageController.prototype.saveIndex = function () {
    "use strict";
    var self = this;
    self._messageIndex = self._rotateIndex(self._messageIndex);
    // save index on server side
    YoutubeStorageManager.savePlayerData([self._backendTag], [self._messageIndex], function () {
    }, function (error) {
        throw new Error("Error while saving powerup data on Server");
    });
};
CustomMessageController.prototype.getInviteTag = function () {
    "use strict";
    return this._inviteTags[this.getMessageIndex()];
};
CustomMessageController.prototype.getMessageIndex = function () {
    "use strict";
    return this._messageIndex;
};
CustomMessageController.prototype.queueMessages = function (state) {
    "use strict";
    switch (state) {
        case "poke":
            this._queuePoke();
            break;
        case "group":
            this._queueGroup();
            break;
    }
};
CustomMessageController.prototype._queuePoke = function () {
    "use strict";
    var nudgeMsg = NudgeFactory.GetPremadeNudge('update', 3, {});
    var localizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.pokeMessage, [
        profileManager.getFirstName(tgfHooks.getPlayerID())
    ]);
    var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization(CustomUpdateSettings.pokeCTA);
    tgfHooks.updateAsync(function () { }, "poke", nudgeMsg, CTAlocalizations, // CTA
    localizations, { "tag": "custom_update" }, function () { }, "LAST");
};
CustomMessageController.prototype._queueGroup = function () {
    "use strict";
    var groupMsg = NudgeFactory.GetPremadeNudge('update', 2, {});
    var localizations = NudgeFactory.GenerateCustomUpdateLocalization('GROUP_MSG_TEXT', [
        tgfHooks.getPlayerName()
    ]);
    var CTAlocalizations = NudgeFactory.GenerateCustomUpdateLocalization('GROUP_MSG_CTA_TEXT');
    AngryAnalytics.reportGroupCustomMessages();
    tgfHooks.updateAsync(function () { }, "group", groupMsg, CTAlocalizations, localizations, { "tag": "group" }, function () { }, "LAST");
};
